<template>
    <loader v-if="isLoading == true" name="spinning" loadingText="Cargando..." textColor="#ffffff" textSize="20" textWeight="500" object="#ff9633" color1="#ffffff" color2="#17fd3d" size="5" speed="2" bg="#343a40" objectbg="#999793" opacity="80" :disableScrolling="true"></loader>

    <div class="form-container">
      <!-- Primera fila: Administración I.V.A.S.A -->
      <div class="row">
        <div class="column">
          <h3>Administración - Factura Anticipo I.V.A.S.A</h3>
          <div class="form-group">
            <label for="rfc-cliente-anticip">R.F.C. Cliente<span class="is-invalid">*</span></label>
            <input type="text" id="rfc-cliente-anticip" v-model="fields.anticipoIvaSa.rfc_cliente" required/>
          </div>
          <div class="form-group">
            <label for="num-factura-anticip">Número de factura<span class="is-invalid">*</span></label>
            <input type="text" id="num-factura-anticip" v-model="fields.anticipoIvaSa.numero_factura" required/>
          </div>
          <div class="form-group">
            <label for="fecha-anticip">Fecha<span class="is-invalid">*</span></label>
            <input type="date" id="fecha-anticip" v-model="fields.anticipoIvaSa.fecha" required/>
          </div>
          <div class="form-group">
            <label for="importe-anticip">Importe<span class="is-invalid">*</span></label>
            <input type="number" id="importe-anticip" v-model="fields.anticipoIvaSa.importe" required/>
          </div>
          <div class="form-group">
            <label for="importe-iva-anticip">Importe con IVA<span class="is-invalid">*</span></label>
            <input type="number" id="importe-iva-anticip" v-model="fields.anticipoIvaSa.importe_con_iva" required/>
          </div>
          <div class="form-group">
            <label for="concepto-anticip">Concepto<span class="is-invalid">*</span></label>
            <input type="text" id="concepto-anticip" v-model="fields.anticipoIvaSa.concepto" required/>
          </div>
          <div class="form-group">
            <label for="fecha-pago-anticip">Fecha de pago<span class="is-invalid">*</span></label>
            <input type="date" id="fecha-pago-anticip" v-model="fields.anticipoIvaSa.fecha_de_pago" required/>
          </div>
        </div>
  
        <div class="column">
          <h3>Administración - Factura Finiquito I.V.A.S.A</h3>
          <div class="form-group">
            <label for="rfc-cliente-finiquito">R.F.C. Cliente<span class="is-invalid">*</span></label>
            <input type="text" id="rfc-cliente-finiquito" v-model="fields.finiquitoIvaSa.rfc_cliente" required/>
          </div>
          <div class="form-group">
            <label for="num-factura-finiquito">Número de factura<span class="is-invalid">*</span></label>
            <input type="text" id="num-factura-finiquito" v-model="fields.finiquitoIvaSa.numero_factura" required/>
          </div>
          <div class="form-group">
            <label for="fecha-finiquito">Fecha<span class="is-invalid">*</span></label>
            <input type="date" id="fecha-finiquito" v-model="fields.finiquitoIvaSa.fecha" required/>
          </div>
          <div class="form-group">
            <label for="importe-finiquito">Importe<span class="is-invalid">*</span></label>
            <input type="number" id="importe-finiquito" v-model="fields.finiquitoIvaSa.importe" required/>
          </div>
          <div class="form-group">
            <label for="importe-iva-finiquito">Importe con IVA<span class="is-invalid">*</span></label>
            <input type="number" id="importe-iva-finiquito" v-model="fields.finiquitoIvaSa.importe_con_iva" required/>
          </div>
          <div class="form-group">
            <label for="concepto-finiquito">Concepto<span class="is-invalid">*</span></label>
            <input type="text" id="concepto-finiquito" v-model="fields.finiquitoIvaSa.concepto" required/>
          </div>
          <div class="form-group">
            <label for="fecha-pago-finiquito">Fecha de pago<span class="is-invalid">*</span></label>
            <input type="date" id="fecha-pago-finiquito" v-model="fields.finiquitoIvaSa.fecha_de_pago" required/>
          </div>
        </div>
      </div>
  
      <!-- Segunda fila: Administración Inspector -->
      <div class="row">
        <div class="column">
          <h3>Administración - Factura Anticipo Inspector</h3>
          <div class="form-group">
            <label for="rfc-inspector-anticip">R.F.C. Inspector<span class="is-invalid">*</span></label>
            <input type="text" id="rfc-inspector-anticip" v-model="fields.anticipoInspector.rfc_cliente" required/>
          </div>
          <div class="form-group">
            <label for="num-factura-inspector-anticip">Número de factura<span class="is-invalid">*</span></label>
            <input type="text" id="num-factura-inspector-anticip" v-model="fields.anticipoInspector.numero_factura" required/>
          </div>
          <div class="form-group">
            <label for="fecha-inspector-anticip">Fecha<span class="is-invalid">*</span></label>
            <input type="date" id="fecha-inspector-anticip" v-model="fields.anticipoInspector.fecha" required/>
          </div>
          <div class="form-group">
            <label for="importe-inspector-anticip">Importe<span class="is-invalid">*</span></label>
            <input type="number" id="importe-inspector-anticip" v-model="fields.anticipoInspector.importe" required/>
          </div>
          <div class="form-group">
            <label for="importe-iva-inspector-anticip">Importe con IVA<span class="is-invalid">*</span></label>
            <input type="number" id="importe-iva-inspector-anticip" v-model="fields.anticipoInspector.importe_con_iva" required/>
          </div>
          <div class="form-group">
            <label for="concepto-inspector-anticip">Concepto<span class="is-invalid">*</span></label>
            <input type="text" id="concepto-inspector-anticip" v-model="fields.anticipoInspector.concepto" required/>
          </div>
          <div class="form-group">
            <label for="fecha-pago-inspector-anticip">Fecha de pago<span class="is-invalid">*</span></label>
            <input type="date" id="fecha-pago-inspector-anticip" v-model="fields.anticipoInspector.fecha_de_pago" required/>
          </div>
        </div>
  
        <div class="column">
          <h3>Administración - Factura Finiquito Inspector</h3>
          <div class="form-group">
            <label for="rfc-inspector-finiquito">R.F.C. Inspector<span class="is-invalid">*</span></label>
            <input type="text" id="rfc-inspector-finiquito" v-model="fields.finiquitoInspector.rfc_cliente" required/>
          </div>
          <div class="form-group">
            <label for="num-factura-inspector-finiquito">Número de factura<span class="is-invalid">*</span></label>
            <input type="text" id="num-factura-inspector-finiquito" v-model="fields.finiquitoInspector.numero_factura" required/>
          </div>
          <div class="form-group">
            <label for="fecha-inspector-finiquito">Fecha<span class="is-invalid">*</span></label>
            <input type="date" id="fecha-inspector-finiquito" v-model="fields.finiquitoInspector.fecha" required/>
          </div>
          <div class="form-group">
            <label for="importe-inspector-finiquito">Importe<span class="is-invalid">*</span></label>
            <input type="number" id="importe-inspector-finiquito" v-model="fields.finiquitoInspector.importe" required/>
          </div>
          <div class="form-group">
            <label for="importe-iva-inspector-finiquito">Importe con IVA<span class="is-invalid">*</span></label>
            <input type="number" id="importe-iva-inspector-finiquito" v-model="fields.finiquitoInspector.importe_con_iva" required/>
          </div>
          <div class="form-group">
            <label for="concepto-inspector-finiquito">Concepto<span class="is-invalid">*</span></label>
            <input type="text" id="concepto-inspector-finiquito" v-model="fields.finiquitoInspector.concepto" required/>
          </div>
          <div class="form-group">
            <label for="fecha-pago-inspector-finiquito">Fecha de pago<span class="is-invalid">*</span></label>
            <input type="date" id="fecha-pago-inspector-finiquito" v-model="fields.finiquitoInspector.fecha_de_pago" required/>
          </div>
        </div>
      </div>
      <button v-if="existenDatos == false" @click="guardar" class="btn btn-dark">Enviar Todos los Datos</button>
      <button v-if="existenDatos == true" @click="guardar" class="btn btn-warning">Actualizar Datos</button>

    </div>
  </template>
  
  <script>
  import { reactive } from "vue";
  import axios from "axios";
  import Swal from 'sweetalert2';
  export default {
    data() {
        return {
            isLoading:false,
            existenDatos:false,
            fields:{
                anticipoIvaSa: {
                    id:"",
                    rfc_cliente: "",
                    numero_factura: "",
                    fecha: "",
                    importe: 0.0,
                    importe_con_iva: 0.0,
                    concepto: "",
                    fecha_de_pago: "",
                    tipo_persona:'General',
                    tipo_factura:'anticipo',
                    id_cotizacion:localStorage.getItem('idcotizacion'),
                    id_inspeccion:localStorage.getItem('idinspeccion'),
                    usuario:localStorage.getItem('email')

                },
                finiquitoIvaSa: {
                    id:"",
                    rfc_cliente:'',
                    numero_factura:'',
                    fecha:'',
                    importe:'',
                    importe_con_iva:'',
                    concepto:'',
                    fecha_de_pago:'',
                   
                    id_cotizacion:localStorage.getItem('idcotizacion'),
                    id_inspeccion:localStorage.getItem('idinspeccion'),
                    usuario:localStorage.getItem('email'),
                    tipo_persona:'General',
                    tipo_factura:'finiquito',
                },
                anticipoInspector: {
                    id:"",
                    rfc_cliente:'',
                    numero_factura:'',
                    fecha:'',
                    importe:'',
                    importe_con_iva:'',
                    concepto:'',
                    fecha_de_pago:'',
                    
                    id_cotizacion:localStorage.getItem('idcotizacion'),
                    id_inspeccion:localStorage.getItem('idinspeccion'),
                    usuario:localStorage.getItem('email'),
                    tipo_persona:'Inspector',
                    tipo_factura:'anticipo',
                },
                finiquitoInspector: {
                    id:"",
                    rfc_cliente:'',
                    numero_factura:'',
                    fecha:'',
                    importe:'',
                    importe_con_iva:'',
                    concepto:'',
                    fecha_de_pago:'',
                    tipo_persona:'',
                    tipo_factura:'',
                    id_cotizacion:localStorage.getItem('idcotizacion'),
                    id_inspeccion:localStorage.getItem('idinspeccion'),
                    usuario:localStorage.getItem('email'),
                   
                    tipo_persona:'Inspector',
                    tipo_factura:'finiquito'
                }
            }
        }
    },
    created() {
        this.consultar();
    },
    methods: {
        async guardar(){
            try {
            const response = await axios.post(this.$rutaServer+'guardarFacturas', this.fields);
            if(response.status == 201){
                if(this.existenDatos == false){
                    Swal.fire('¡Éxito!', 'Datos almacenados', 'success');

                }
                else{
                    Swal.fire('¡Éxito!', 'Datos actualizados', 'success');

                }
            }
                console.log('Datos guardados:', response.data);
            } catch (error) {
                console.error('Error al guardar datos:', error);
            }
        },
        async consultar(){
            this.isLoading = true;
            try {
                var id_inspeccion = localStorage.getItem('idinspeccion');
            const response = await axios.post(this.$rutaServer+'consultarFacturas', {idinspeccion:id_inspeccion});
                console.log('Datos guardados:', response.data);
                if(response.status == 200){
                    this.isLoading = false;
                    var datos = response.data.data;
                    if(datos.length > 0){
                        this.existenDatos = true;
                        datos.forEach(ele => {
                            if(ele.tipo_persona == 'General' && ele.tipo_factura == 'anticipo'){
                                var obj = {
                                    id:ele.id,
                                    rfc_cliente:ele.rfc_cliente,
                                    numero_factura:ele.numero_factura,
                                    fecha:ele.fecha,
                                    importe:ele.importe,
                                    importe_con_iva:ele.importe_con_iva,
                                    concepto:ele.concepto,
                                    fecha_de_pago:ele.fecha_de_pago,
                                    id_cotizacion:ele.id_cotizacion,
                                    id_inspeccion:ele.id_inspeccion,
                                    tipo_persona:'General',
                                    tipo_factura:'anticipo',
                                    usuario:ele.usuario
                                };
                                this.fields.anticipoIvaSa = obj;
                            }

                            else if(ele.tipo_persona == 'General' && ele.tipo_factura == 'finiquito'){
                                var obj = {
                                    id:ele.id,
                                    rfc_cliente:ele.rfc_cliente,
                                    numero_factura:ele.numero_factura,
                                    fecha:ele.fecha,
                                    importe:ele.importe,
                                    importe_con_iva:ele.importe_con_iva,
                                    concepto:ele.concepto,
                                    fecha_de_pago:ele.fecha_de_pago,
                                    id_cotizacion:ele.id_cotizacion,
                                    id_inspeccion:ele.id_inspeccion,
                                    tipo_persona:'General',
                                    tipo_factura:'finiquito',
                                    usuario:ele.usuario

                                };
                                this.fields.finiquitoIvaSa = obj;
                            }

                            //Inspector
                            if(ele.tipo_persona == 'Inspector' && ele.tipo_factura == 'anticipo'){
                                var obj = {
                                    id:ele.id,
                                    rfc_cliente:ele.rfc_cliente,
                                    numero_factura:ele.numero_factura,
                                    fecha:ele.fecha,
                                    importe:ele.importe,
                                    importe_con_iva:ele.importe_con_iva,
                                    concepto:ele.concepto,
                                    fecha_de_pago:ele.fecha_de_pago,
                                    id_cotizacion:ele.id_cotizacion,
                                    id_inspeccion:ele.id_inspeccion,
                                    tipo_persona:'Inspector',
                                    tipo_factura:'anticipo',
                                    usuario:ele.usuario

                                };
                                this.fields.anticipoInspector = obj;
                            }

                            else if(ele.tipo_persona == 'Inspector' && ele.tipo_factura == 'finiquito'){
                                var obj = {
                                    id:ele.id,
                                    rfc_cliente:ele.rfc_cliente,
                                    numero_factura:ele.numero_factura,
                                    fecha:ele.fecha,
                                    importe:ele.importe,
                                    importe_con_iva:ele.importe_con_iva,
                                    concepto:ele.concepto,
                                    fecha_de_pago:ele.fecha_de_pago,
                                    id_cotizacion:ele.id_cotizacion,
                                    id_inspeccion:ele.id_inspeccion,
                                    tipo_persona:'Inspector',
                                    tipo_factura:'finiquito',
                                    usuario:ele.usuario

                                };
                                this.fields.finiquitoInspector = obj;
                            }
                        });
                    }
                }
            } catch (error) {
                console.error('Error al guardar datos:', error);
            }
        },
    },
    
  };
  </script>
  
  <style scoped>
  
  .is-invalid {
      color: red;
  }
  .form-container {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  
  .row {
    display: flex;
    justify-content: space-between;
  }
  
  .column {
    flex: 1;
    min-width: 300px;
    margin: 10px;
    padding: 15px;
    border: 1px solid #ccc;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
  
  h3 {
    margin-bottom: 20px;
    font-size: 18px;
    color: #333;
  }
  
  .form-group {
    margin-bottom: 15px;
  }
  
  label {
    display: block;
    font-weight: bold;
    margin-bottom: 5px;
  }
  
  input[type="text"],
  input[type="number"],
  input[type="date"] {
    width: 100%;
    padding: 8px;
    font-size: 14px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
  }
  
  input[type="number"] {
    -moz-appearance: textfield;
  }
  
  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  </style>
  